import { BlockType } from '../../types/index.js';
import { MarkdownBlock as Component } from './Block.js';
export const RegisteredMarkdownBlock = (_intl) => ({
    recommendedName: 'Markdown',
    Component,
    config: {
        type: BlockType.Block,
    },
});
//# sourceMappingURL=registered.js.map